<template>
  <b-row class="tandavital" :style="elZoom">
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Suhu <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>C</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.suhu : null })"
              @keypress="checkInputSpecial"
              type="text"
              id="suhu"
              :value="pasien.suhu != null && pasien.suhu != '' ? pasien.suhu.toString().replace(',','.') : ''"
              @input="updateData({key: 'suhu', value: $event})"
            />
          </b-input-group>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Sistole <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>mmHg</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.tensi_sistole : null })"
              @keypress="checkInput"
              type="text"
              id="tensi_sistole"
              :value="pasien.tensi_sistole || ''"
              @input="updateData({key: 'tensi_sistole', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.tensi_sistole
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Diastole <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>mmHg</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.tensi_diastole : null })"
              @keypress="checkInput"
              type="text"
              id="tensi_diastole"
              :value="pasien.tensi_diastole || ''"
              @input="updateData({key: 'tensi_diastole', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.tensi_diastole
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Nadi <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>x/menit</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.nadi : null })"
              @keypress="checkInput"
              type="text"
              id="nadi"
              :value="pasien.nadi || ''"
              @input="updateData({key: 'nadi', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.nadi
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Respirasi <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>x/menit</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.respirasi : null })"
              @keypress="checkInput"
              type="text"
              id="respirasi"
              :value="pasien.respirasi || ''"
              @input="updateData({key: 'respirasi', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.respirasi
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">SpO2</label>
        <br />
        <template>
          <b-input-group :class="{'mt-2': saving_params.is_bpjs}">
            <template #append>
              <b-input-group-text>%</b-input-group-text>
            </template>
            <b-form-input
              @keypress="checkInput"
              type="text"
              id="saturasi_oksigen"
              :value="pasien.saturasi_oksigen != null && pasien.saturasi_oksigen != '' ? pasien.saturasi_oksigen.toString().replace(',','.') : ''"
              @input="updateData({key: 'saturasi_oksigen', value: $event})"
            />
          </b-input-group>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Tinggi Badan <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>cm</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.tinggi_badan : null })"
              @keypress="checkInputSpecial"
              type="text"
              id="tinggi_badan"
              :value="pasien.tinggi_badan != null && pasien.tinggi_badan != '' ? pasien.tinggi_badan.toString().replace(',','.') : ''"
              @input="updateData({key: 'tinggi_badan', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.tinggi_badan
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Berat Badan <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>kg</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.berat_badan : null })"
              @keypress="checkInputSpecial"
              type="text"
              id="berat_badan"
              :value="pasien.berat_badan != null && pasien.berat_badan != '' ? pasien.berat_badan.toString().replace(',','.') : ''"
              @input="updateData({key: 'berat_badan', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.berat_badan
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          Lingkar Perut <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>cm</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.lingkar_perut : null })"
              @keypress="checkInput"
              type="text"
              id="lingkar_perut"
              :value="pasien.lingkar_perut || ''"
              @input="updateData({key: 'lingkar_perut', value: $event})"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.lingkar_perut
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group style="position: relative">
        <label class="text-subtitle">
          IMT <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
        </label>
        <br />
        <template>
          <b-input-group>
            <template #append>
              <b-input-group-text>kg/m2</b-input-group-text>
            </template>
            <b-form-input
              :state="renderError({ error: saving_params.is_bpjs ? errForm.imt : null })"
              :readonly="true"
              type="text"
              id="imt"
              :value="imt"
            />
          </b-input-group>
          <span style="font-size:.85rem;color:red" v-if="saving_params.is_bpjs">{{
            errForm.imt
          }}</span>
        </template>
      </b-form-group>
    </b-col>
    <b-col cols="2" v-show="saving_params.is_poli_gigi">
      <b-form-group style="position: relative">
        <label class="text-subtitle">Golongan Darah</label>
        <br />
        <template>
          <vue-select
            :options="option_blood"
            placeholder="Pilih Gol. Darah"
            v-model="selectedBlood"
            class="__form-select __select-relative"
            :class="{'mt-2': saving_params.is_bpjs}"
            @input="updateData({key: 'golongan_darah', value: $event})"
          >
          </vue-select>
        </template>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ObjectiveTandaVital',
  components: {
    'vue-select': () => import('@/components/VueSelectClearable.vue'),
  },
  data: () => ({
    imt: 0,
    option_blood: [
      { label: 'A', value: 'A' },
      { label: 'AB', value: 'AB' },
      { label: 'B', value: 'B' },
      { label: 'O', value: 'O' },
      { label: 'Tidak Diketahui', value: 'N' },
    ],
    selectedBlood: null,
    errForm: {
      tensi_sistole: null,
      tensi_diastole: null,
      berat_badan: null,
      tinggi_badan: null,
      respirasi: null,
      nadi: null,
      anamnesa: null,
      suhu: null,
      lingkar_perut: null,
      imt: null,
    },
    elZoom: 'zoom: 100%;',
  }),
  computed: {
    ...mapState(['sidebar']),
    ...mapGetters('sidebar', ['collapsed', 'collapsedMobile']),
    ...mapGetters(['pasien', 'saving_params', 'trx']),
    ...mapState(['rm']),
    ...mapGetters('rm', ['pasienGolonganDarah']),
  },
  mounted() {
    this.resizeWidth(window.innerWidth);
    this.imt = this.pasien.imt;
    this.selectedBlood = this.option_blood.find(b => b.value == this.pasien.golongan_darah);
  },
  watch: {
    'pasien.tinggi_badan': function(newVal, oldVal) {
      this.updateIMT({...this.pasien, tinggi_badan: newVal});
      if (newVal) {
        if (newVal < 30 || newVal > 210) {
          this.errForm.tinggi_badan = 'minimal 30 Cm, maksimal 210 Cm'
        } else {
          this.errForm.tinggi_badan = null;
        }
      }
      else this.errForm.tinggi_badan = ' '
    },
    'pasien.berat_badan': function(newVal, oldVal) {
      this.updateIMT({...this.pasien, berat_badan: newVal});
      if (newVal) {
        if (newVal < 2 || newVal > 300) {
          this.errForm.berat_badan = 'minimal 2 Kg, maksimal 300 Kg'
        } else {
          this.errForm.berat_badan = null;
        }
      }
      else this.errForm.berat_badan = ' '
    },
    'pasien.golongan_darah': function() {
      this.selectedBlood = this.option_blood.find(b => b.value == this.pasien.golongan_darah);
    },
    'pasien.tensi_sistole': function(newVal, oldVal) {
      if (newVal) {
        if (newVal < 40 || newVal > 250) {
          this.errForm.tensi_sistole = 'minimal 40 MmHg, maksimal 250 MmHg'
        } else {
          this.errForm.tensi_sistole = null;
        }
      }
      else this.errForm.tensi_sistole = ' '
    },
    'pasien.tensi_diastole': function(newVal, oldVal) {
      if (newVal) {
        if (newVal < 30 || newVal > 180) {
          this.errForm.tensi_diastole = 'minimal 30 MmHg, maksimal 180 MmHg'
        } else {
          this.errForm.tensi_diastole = null;
        }
      }
      else this.errForm.tensi_diastole = ' '
    },
    'pasien.respirasi': function(newVal, oldVal) {
      if (newVal) {
        if (newVal < 5 || newVal > 70) {
          this.errForm.respirasi = 'minimal 5x, maksimal 70x'
        } else {
          this.errForm.respirasi = null;
        }
      }
      else this.errForm.respirasi = ' '
    },
    'pasien.nadi': function(newVal, oldVal) {
      if (newVal) {
        if (newVal < 30 || newVal > 160) {
          this.errForm.nadi = 'minimal 30x, maksimal 160x'
        } else {
          this.errForm.nadi = null;
        }
      }
      else this.errForm.nadi = ' '
    },
    'pasien.suhu': function(newVal, oldVal) {
      if (newVal) {
        this.errForm.suhu = null
      }
      else this.errForm.suhu = ' '
    },
    'pasien.lingkar_perut': function(newVal, oldVal) {
      if (newVal) {
        this.errForm.lingkar_perut = null
      }
      else this.errForm.lingkar_perut = ' '
    },
    'imt': function(newVal, oldVal) {
      if (newVal) {
        this.errForm.imt = null
      }
      else this.errForm.imt = ' '
    },
    pasienGolonganDarah: {
        handler: function (val) {
          this.selectedBlood = this.option_blood.find(b => b.value == val);
        },
        deep: true,
        immediate: true
    },
    collapsed() {
      this.resizeWidth(window.innerWidth);
    },
    collapsedMobile() {
      this.resizeWidth(window.innerWidth);
    },
  },
  methods: {
    ...mapActions(['updateTandaVital', 'updatePasien']),
    resizeWidth(w) {
      let n = 15;
      if (w < 770) n = 7.5;
      else if (w < 1200 && w > 769) n = 13.5;
      
      let zoom = w / n;
      if (zoom > 100) zoom = 100;
      this.elZoom = `zoom: ${zoom}%;`;
    },
    checkInput($event) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^0-9]/.test(key)) {
        evt.preventDefault();
      }
    },
    checkInputSpecial($event) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^0-9.,]/.test(key)) {
        evt.preventDefault();
      }
    },
    updateIMT(data) {
      if (parseInt(data.tinggi_badan) && parseInt(data.berat_badan)) {
        let tinggi_badan = parseInt(data.tinggi_badan) * 0.01;
        let newImt = parseInt(data.berat_badan) / (tinggi_badan * tinggi_badan);
        this.imt = newImt.toFixed(2);
        this.updateTandaVital({key: 'imt', value: this.imt});
      } else {
        this.imt = null;
        this.updateTandaVital({key: 'imt', value: null});
      }
    },
    updateData(data) {
      if (data.key == 'tinggi_badan') {
        this.updatePasien({
          data: {...this.pasien, tinggi_badan: data.value}
        });
      }
      if (data.key == 'berat_badan') {
        this.updatePasien({
          data: {...this.pasien, berat_badan: data.value}
        });
      }
      if (['tensi_sistole', 'tensi_diastole', 'nadi', 'respirasi', 'anamnesa', 'nadi', 'suhu', 'lingkar_perut'].includes(data.key)) {
        this.updatePasien({
          data: {...this.pasien, [data.key]: data.value}
        });
      }

      let obj = ['golongan_darah'];
      if (obj.includes(data.key) && data.value && typeof data.value == 'object') {
        data.value = data.value.value;
        this.$store.commit('rm/SET_PASIEN_GOL_DARAH', data.value);
      }
      this.updateTandaVital(data);
    },
  },
};
</script>

<style>
  .tandavital .input-group-append .input-group-text{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
  .tandavital .form-control {
    height: calc(1.5em + 1.06rem + 3px) !important;
  }
</style>
